var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the materials of damaged veranda panels.
 * touches: declaration, externalDamage, verandaDamage
 * invariants: The selected materials list is synchronized with the parent component through v-model.
 * inputs: selected materials list, available panel material choices
 * outputs: updates the material selection used for damaged panels.
 * see: @declaration/components/externalDamage/DamageDescription/Veranda/Veranda.vue
 */
import { Component, VModel } from 'vue-property-decorator';
import { UiCheckbox, UiCard } from '@claims-ia/design-system';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { VERANDA_PANELS_MATERIAL_CHOICES } from '@shared/constants/externalDamages/VerandaConstants';
import { VERANDA_PANELS_TITLE } from '@declaration/constants/externalDamages/VerandaConstants';
let VerandaPanelMaterials = class VerandaPanelMaterials extends ExternalDamageComponent {
    get choices() {
        return VERANDA_PANELS_MATERIAL_CHOICES.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    get title() {
        return this.translateExternalDamageKey(VERANDA_PANELS_TITLE);
    }
};
__decorate([
    VModel({ type: Array, default: () => [] })
], VerandaPanelMaterials.prototype, "materials", void 0);
VerandaPanelMaterials = __decorate([
    Component({ components: { UiCheckbox, UiCard } })
], VerandaPanelMaterials);
export default VerandaPanelMaterials;
